<template>
  <div class="pa-park-note-comment" v-if="isLoadedParkNoteComment">
    <div class="text">{{parkNoteComment.body}}</div>

    <PASimpleMessageAttachImagesView  :images="parkNoteComment.images" />
    
    <div class="pa-character-meta">
      <CharacterIcon :character="parkNoteComment.character" />
      <div class="pa-name">{{parkNoteComment.character.displayname | nameTruncate}}</div>
      <div class="controls">
        <button class="button control-button" @click.prevent="handleClickNoteCommentTrash" v-if="parkNoteComment.could_delete">
          <font-awesome-icon icon="trash" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'

import {GetParkNote} from '@/graphql/queries/ParkNote.graphql'
import {GetParkNoteComment} from '@/graphql/queries/ParkNoteComment.graphql'

import PASimpleMessageAttachImagesView  from '@/components/Parts/PASimpleMessageAttachImagesView/PASimpleMessageAttachImagesView.vue';

export default {
  props : {
    commentId : {
      default: null
    }
  },
  
  components : {
    CharacterIcon,
    PASimpleMessageAttachImagesView
  },

  apollo : {
    parkNote : {
      query : GetParkNote,
      variables(){
        return {
          id : this.noteId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    parkNoteComment : {
      query : GetParkNoteComment,
      variables(){
        return {
          id : this.commentId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },
  },

  computed : {
    noteId(){
      return this.$route.params.noteId;
    },

    isLoadedParkNoteComment(){
      if(typeof this.parkNoteComment === 'undefined'){
        return false;
      }else{
        return true;
      }
    }
  },

  methods : {
    handleClickNoteCommentTrash(){
      if(this.parkNoteComment.could_delete === false) return;

      this.$store.dispatch({
        type            : 'parkNoteDeleteModal/updateModal',
        isOpen          : true,
        isFreezModal    : false,
        isSubmitLoading : false,
        behaviour       : 'deleteNoteComment',
        parkNote        : this.parkNote,
        parkNoteComment : this.parkNoteComment
      });
    }
  }
}
</script>

<style lang="scss">
.pa-park-note-comment{
  // color:#7C5E49;
  color:#604938;

  .pa-character-meta{
    margin:.4rem auto 0;
    padding-top: .3rem;
    width:98%;
    position: relative;
    
    display: flex;
    text-align: right;
    justify-content:flex-end;
    font-size:.8rem;

    .pa-character-icon{
      color:#795B46;
      margin:0;
      width:30px;
      height:30px;
      background-color:#BD9C75;
      font-size:14px;
      line-height:28px;
    }

    .pa-name{
      margin-left: .3rem;
      line-height: 30px;;
    }

    .controls{
      position: absolute;
      bottom:0;
      left:0;

      .control-button{
        margin:0 .5rem 0 0;
        padding:.1rem 1rem;
        height:1rem;
        font-size:.7rem;
        border:0;
        background-color: #BB9D79;
        color:#7D593C;
        border-radius: 6px;

        &:last-child{
          margin-right:0;
        }
      }
    }
  }
}
</style>